<style lang="scss" scoped>
.cashier-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f6f6f6;
  height: 100vh;
  .cashier-page-container {
    flex: 1;
    flex-shrink: 0;
    overflow-y: auto;
    .cost-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 60px 0 80px 0;
      .cost-number {
        font-weight: bold;
        font-size: 48px;
        color: #202020;
        line-height: 66px;
      }
      .cost-label {
        margin-top: 16px;
        font-size: 28px;
        color: #999;
        line-height: 40px;
      }
    }
    .pay-list {
      padding: 0 42px;
      box-sizing: border-box;
      .pay-item-wrap {
        width: 100%;
      }
      .pay-item-bg {
        width: 100%;
        height: 120px;
        overflow: hidden;
        border-radius: 16px;
        box-sizing: border-box;
        margin-bottom: 32px;
        // 模拟实现一个带圆角的渐变边框
        &.checked {
          // border-image: linear-gradient(#BFEDFE, #A1C4FD);
          // border-image-slice: 10;
          background-image: linear-gradient(to bottom, #BFEDFE, #A1C4FD);
          box-shadow: 0px 8px 16px 0 rgba($color: #B0D5FC, $alpha: .2);
        }
        .pay-item {
          position: relative;
          display: flex;
          align-items: center;
          width: calc(100% - 4px);
          height: calc(100% - 5px);
          // padding: 10px;
          margin: 3px 0 0 2px;
          border-radius: 16px;
          // border: 2px solid #EEEEEE;
          background-color: white;
          box-sizing: border-box;
          // background-origin: content-box;
        }
        .pay-icon {
          width: 54px;
          height: 54px;
          margin-right: 16px;
          margin-left: 24px;
        }
        .pay-name {
          font-size: 30px;
          color: #202020;
          line-height: 40px;
        }
        .check-icon {
          position: absolute;
          right: -2px;
          top: -2px;
          height: 48px;
          width: 48px;
          background-image: url('https://oss.turingsenseai.com/1607148932982059206.png');
          background-size: 100% 100%;
        }
      }
    }
  }
  .cashier-footer {
    padding: 24px;
    background-color: white;
    padding-bottom: 68px;
    box-shadow: 0px -4px 18px rgba(0, 0, 0, .03);
    .pay-btn {
      width: 702px;
      color: #fff;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #000;
      border-radius: 4px;
    }
  }
}
</style>

<template>
<div class="cashier-page">
  <div class="cashier-page-container">
    <div class="cost-info">
      <div class="cost-number">{{payMount}}</div>
      <div class="cost-label">支付金额</div>
    </div>
    <div class="pay-list">
      <div class="pay-item-wrap" @click="changePayType('wxpay')">
        <div :class="`pay-item-bg ${payType=='wxpay' ? 'checked' : ''}`">
          <div class="pay-item">
            <img class="pay-icon" src="https://oss.turingsenseai.com/1607147614952277875.png" />
            <div class="pay-name">微信</div>
            <div class="check-icon" v-if="payType=='wxpay'"></div>
          </div>
        </div>
      </div>

      <div class="pay-item-wrap" @click="changePayType('alipay')">
        <div :class="`pay-item-bg ${payType=='alipay' ? 'checked' : ''}`">
          <div class="pay-item">
            <img class="pay-icon" src="https://oss.turingsenseai.com/1607147672946847697.png" />
            <div class="pay-name">支付宝</div>
            <div class="check-icon" v-if="payType=='alipay'"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cashier-footer">
    <div class="pay-btn" @click="getPayMsg()">确认支付</div>
  </div>
</div>
</template>

<script>
import { fetchPay, webPageOpenid, payOnWxBrowser } from '../../../common/api/bag-show'
import { HOST_ADDRESS } from '../../../common/constant'
import { Toast } from 'vant'
const appid = 'wx336439508d336e22'
const isWechatBrowser = /MicroMessenger/i.test((navigator && navigator.userAgent) || '')

export default {
  data() {
    return {
      payType: 'wxpay',
      orderNo: '',
      payMount: '',
      pid: '',
      isWechatBrowser: false,
      openid: '',
      state: '',
      code: ''

    }
  },
  created () {
    const { orderNo, payMount, pid, code, state } = this.$route.query
    console.log(orderNo, payMount, pid)
    this.orderNo = orderNo
    this.payMount = payMount
    this.pid = pid
    this.code = code
    this.state = state

    this.getOpenId()
  },
  methods: {
    changePayType(type) {
      this.payType = type
    },
    async getOpenId() {
      // const openId = localStorage.getItem('wx_auth_openId')
      // 如果是微信浏览器，并且没有openId
      if (isWechatBrowser) {
        if (this.code) { // 收银台：微信授权成功
          const openIdRes = await webPageOpenid({ code: this.code })
          // Toast('openIdRes:' + JSON.stringify(openIdRes))
          if (openIdRes && openIdRes.errorCode === 0) {
            localStorage.setItem('wx_auth_openId', openIdRes.openid) // 缓存 openid
          }
        } else { // 去授权微信获取 code
          // Taro.showLoading({ title: '去授权 code' })
          // 注意redirect_uri路径必须是http协议开头 不可以使用https
          const redirectUrl =
            `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid
            }&redirect_uri=${
            // 该项目是哈希路由 微信redirect_uri授权路径规则不支持哈希路由
            encodeURIComponent('http://' + window.location.hostname + '/wxredirect/index.html?refer=' + encodeURIComponent(window.location.href))
            }&response_type=${'code'
            }&scope=${'snsapi_base'
            }&state=${'cashier'
            }#wechat_redirect`
          // demo：'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx336439508d336e22&redirect_uri=http%3A%2F%2Fbaoh5test.turingsenseai.com%2Fwxredirect%2Findex.html%3Frefer%3Dhttps%253A%252F%252Fbaoh5test.turingsenseai.com%252Fh5%252F%2523%252Fcashier%253ForderNumber%253DEA202012041404366884%2526orderType%253D3&response_type=code&scope=snsapi_base&state=#wechat_redirect'
          // https://baoh5test.turingsenseai.com/wxredirect/index.html?refer=https%3A%2F%2Fbaoh5test.turingsenseai.com%2Fh5%2F%23%2Fcashier%3ForderNumber%3DEA202012041404366884%26orderType%3D3&code=051cNlFa1AP16A0IIDFa1FJXDC0cNlFz&state=
          setTimeout(() => {
            window.location.replace(redirectUrl)
          }, 100)
        }
      }
    },
    getPayMsg() {
      if ( this.payType == 'wxpay' && isWechatBrowser) {
        return this.wxPayment()
      }
      fetchPay({
        orderNo: this.orderNo,
        payType: this.payType,
        quitUrl: `${HOST_ADDRESS()}bag-show/product-detail/${this.pid}`
      }).then(res => {
        if (res && res.errorCode == 0) {
          window.location.href = res.payUrl
        }
      })
    },
    async wxPayment() {
      const openId = localStorage.getItem('wx_auth_openId') // 缓存 openid
      
      if (!openId) {
        return Toast('openId 缺失，请稍后重试(10004)')
      }

      const wxPayOptions = await payOnWxBrowser({ orderNo: this.orderNo, openid: openId })
      this.code = JSON.stringify(wxPayOptions)

      if (wxPayOptions && wxPayOptions.errorCode === 0) {
        this.wxInnerPay({
          appId: appid, // 公众号名称，由商户传入
          timeStamp: wxPayOptions.timestamp, //时间戳，自1970年以来的秒数
          nonceStr: wxPayOptions.nonceStr, //随机串
          __package: wxPayOptions.package,
          signType: wxPayOptions.signType, //微信签名方式：
          paySign: wxPayOptions.paySign //微信签名
        })
      }
    },
    wxInnerPay(params) {
      if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady',() => this.onBridgeReady(params), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', () => this.onBridgeReady(params))
          document.attachEvent('onWeixinJSBridgeReady', () => this.onBridgeReady(params))
        }
      } else {
        this.onBridgeReady(params)
      }
    },
    payCallback(res) {
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        Toast('支付成功')
        setTimeout(() => {
          this.$router.push({ path: `/bag-show/product-detail/${this.pid}` })
        }, 1300)
      } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
        Toast('取消支付')
      } else {
        Toast('支付失败')
      }
    },
    onBridgeReady({ appId, timeStamp, nonceStr, __package /** package 是关潜在键字 不建议使用 */, signType, paySign }) {
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId, //公众号名称，由商户传入
          timeStamp, //时间戳，自1970年以来的秒数
          nonceStr, //随机串
          package: __package,
          signType, //微信签名方式：
          paySign //微信签名
        },
        this.payCallback
      )
    }
  }
}
</script>
